import React, { type PropsWithChildren } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@garnish/constants';
import { useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderIntroFooter = (props: PropsWithChildren) => {
  const { children } = props;

  const { currentBreakpoint } = useResponsive();
  const { bottom: safeAreaBottomInset } = useSafeAreaInsets();

  // ─── Styles ───────────────────────────────────────────────────────────────

  const safeAreaBottomStyle = useStyle(() => {
    const shouldUseSafeAreaBottomInset = Platform.OS !== 'web' && currentBreakpoint.isXS;

    if (!shouldUseSafeAreaBottomInset) return;

    return { paddingBottom: safeAreaBottomInset + theme.spacing['2'] };
  }, [currentBreakpoint.isXS, safeAreaBottomInset]);

  const containerStyles = [styles.container, safeAreaBottomStyle];

  // ─────────────────────────────────────────────────────────────────────────

  return <View style={containerStyles}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    gap: theme.spacing['4'],
    paddingHorizontal: theme.spacing['4'],
    paddingBottom: theme.spacing['3'],
  },
});
